import React, { useEffect, useState } from "react";
import CustomButton from "../../../../components/commons/custom-button/custom-button.component";
import "./training-policies-sidebar.styles.scss";
import { useHistory, useLocation } from "react-router-dom";
import { updateAllowCartStepsAction } from "../../../../redux/shopping-cart/shopping-cart.action";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getAttendees } from "../../../../js/api/shopping-cart/_attendees-cart";
import { handleNotify } from "../../../../js/helpers/toaster/toaster-notify";
import { ToasterTypes } from "../../../../js/helpers/toaster/toaster-types";
import { Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import * as Sentry from "@sentry/react";

const TrainingPolices = ({ buttonText, mainContent, totalAttendeesRequired, products }) => {

    const history = useHistory();
    let location = useLocation();
    const dispatch = useDispatch();
    const [submitting, setSubmitting] = useState(false);
    const [totalexistattendeesrequired, setTotalexistattendeesrequired] = useState([]);
    //const [count]

    const handleReviewOrder = async () => {
        try {
            let checkVariable = false;
            products.forEach(product => {
                let attendee = totalexistattendeesrequired.filter(e => e.variantsku === product.variantsku)[0]
                if (attendee === undefined) {
                    checkVariable = true;
                }
                if (attendee && (attendee.quantity !== product.quantity)) {
                    checkVariable = true;
                }
            })

            if (checkVariable) {
                handleNotify('Fill out all the required attendees before reviewing order.', ToasterTypes.Warning);

            } else {
                setSubmitting(true);
                dispatch(updateAllowCartStepsAction(3));
                history.push(location.pathname + '/review-order');
                setSubmitting(false);
            }
        }
        catch (e) {
            {/* RP - Add Sentry Changes */ }
            Sentry.setExtra("Shopping Cart", "Error in review order");
            Sentry.captureException(new Error(e), {
                tags: {
                    section: "Error in review order"
                },
            });
        }
    }
    const cartitemimpersonate = useSelector(
        ({ cart }) => cart.impersonateMember
    );
    const attendeescountupdate = useSelector(
        ({ cart }) => cart.attendeescount_update,
        shallowEqual
    );


    useEffect(() => {
        try {
            let getcartitemResponse;

            async function getCartAttendees() {
                let memberId;
                if (cartitemimpersonate) {
                    memberId = cartitemimpersonate.memberId;
                }
                getcartitemResponse = await getAttendees(memberId);
                if (getcartitemResponse) {
                    const attendees = getcartitemResponse.Attendees && [].concat.apply([], getcartitemResponse.Attendees.map(e => e.attendees));
                    let attendeesItems = [];
                    getcartitemResponse && getcartitemResponse.Attendees.forEach(e => {
                        attendeesItems = attendeesItems.concat([
                            {
                                variantsku: e.VariantSku,
                                quantity: e.attendees.length
                            }
                        ])
                    })
                    if (attendees && attendees.length > 0) {
                        setTotalexistattendeesrequired(attendeesItems);
                    } else {
                        setTotalexistattendeesrequired(attendeesItems);
                    }
                }
            }
            getCartAttendees();
        }
        catch (e) {
            {/* RP - Add Sentry Changes */ }
            Sentry.setExtra("Shopping Cart", "Error in sidebar binding data");
            Sentry.captureException(new Error(e), {
                tags: {
                    section: "Error in sidebar binding data"
                },
            });
        }
    }, [attendeescountupdate]);

    return (
        <div class="cart-sidebar">
            <div className="top-container">
                <Row>
                    <Col xs={12} lg={12} md={12}>
                        <CustomButton loading={submitting} onClick={handleReviewOrder}>{buttonText}</CustomButton>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} lg={12} md={12}>
                        {
                            mainContent
                                ? <p className="order-blurb">
                                    <div dangerouslySetInnerHTML={{ __html: mainContent.SideHeaderContent }} />
                                </p>
                                : <Skeleton height={150} />
                        }
                    </Col>
                </Row>
            </div>

            <hr />
            {
                mainContent
                    ? <div dangerouslySetInnerHTML={{ __html: mainContent.SideMainContent }} />
                    : <Skeleton height={150} />
            }
        </div>
    );
};

export default TrainingPolices;
